module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-monitor.50ac3f14.webp";